export default "__VITE_ASSET__OGV_vsQw__"